export type MockTestDraft = {
  id: string
  title: string
  description: string
  questionCount: number
  passScorePercent: number
  durationMinutes: number
  attempts: number
}

export type MockModuleDraft = {
  id: string
  title: string
  tests: MockTestDraft[]
}

export type MockCourseDraft = {
  id: string
  title: string
  modules: MockModuleDraft[]
}

export const TEST_DRAFT_COURSE_CATALOG: MockCourseDraft[] = []

export function findTestDraft(
  courseId: string,
  moduleId: string,
  testId: string
): MockTestDraft | null {
  const course = TEST_DRAFT_COURSE_CATALOG.find((c) => c.id === courseId)
  if (!course) return null
  const mod = course.modules.find((m) => m.id === moduleId)
  if (!mod) return null
  return mod.tests.find((t) => t.id === testId) ?? null
}

export function findCourseTitle(courseId: string): string {
  return TEST_DRAFT_COURSE_CATALOG.find((c) => c.id === courseId)?.title ?? ''
}

export function findModuleTitle(
  courseId: string,
  moduleId: string
): string {
  const course = TEST_DRAFT_COURSE_CATALOG.find((c) => c.id === courseId)
  return course?.modules.find((m) => m.id === moduleId)?.title ?? ''
}

export type FlatTestRow = {
  courseId: string
  moduleId: string
  courseTitle: string
  moduleTitle: string
  test: MockTestDraft
}

export function getAllTestsFlat(): FlatTestRow[] {
  const out: FlatTestRow[] = []
  for (const c of TEST_DRAFT_COURSE_CATALOG) {
    for (const m of c.modules) {
      for (const test of m.tests) {
        out.push({
          courseId: c.id,
          moduleId: m.id,
          courseTitle: c.title,
          moduleTitle: m.title,
          test
        })
      }
    }
  }
  return out
}
export type MockTestDraft = {
  id: string
  title: string
  description: string
  questionCount: number
  passScorePercent: number
  durationMinutes: number
  attempts: number
}

export type MockModuleDraft = {
  id: string
  title: string
  tests: MockTestDraft[]
}

export type MockCourseDraft = {
  id: string
  title: string
  modules: MockModuleDraft[]
}

export const TEST_DRAFT_COURSE_CATALOG: MockCourseDraft[] = []

export function findTestDraft(
  courseId: string,
  moduleId: string,
  testId: string
): MockTestDraft | null {
  const course = TEST_DRAFT_COURSE_CATALOG.find((c) => c.id === courseId)
  if (!course) return null
  const mod = course.modules.find((m) => m.id === moduleId)
  if (!mod) return null
  return mod.tests.find((t) => t.id === testId) ?? null
}

export function findCourseTitle(courseId: string): string {
  return TEST_DRAFT_COURSE_CATALOG.find((c) => c.id === courseId)?.title ?? ''
}

export function findModuleTitle(
  courseId: string,
  moduleId: string
): string {
  const course = TEST_DRAFT_COURSE_CATALOG.find((c) => c.id === courseId)
  return course?.modules.find((m) => m.id === moduleId)?.title ?? ''
}

export type FlatTestRow = {
  courseId: string
  moduleId: string
  courseTitle: string
  moduleTitle: string
  test: MockTestDraft
}

export function getAllTestsFlat(): FlatTestRow[] {
  const out: FlatTestRow[] = []
  for (const c of TEST_DRAFT_COURSE_CATALOG) {
    for (const m of c.modules) {
      for (const test of m.tests) {
        out.push({
          courseId: c.id,
          moduleId: m.id,
          courseTitle: c.title,
          moduleTitle: m.title,
          test
        })
      }
    }
  }
  return out
}
